import { IAnimationStateListener } from "pixi-spine";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { IVendorSpinData } from "../../../vendor_core/src/model/IVendorSpinData";
import BURFeatureModel from "../models/BURFeatureModel";
import BURReelsModel from "../models/BURReelsModel";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import { playSceneShake, stopSceneShake } from "../view/SceneShake";
import gsap from "gsap";
import { GameLayers } from "../enums/GameLayers";

const color = "blue";

export default class BURPlayBlueRespinState extends State {
    public async enter() {
        super.enter();

        // Replay popup
        const replayLayer = ViewManager.getLayer(GameLayers.Replay);
        const replayScene =
            replayLayer.getCurrentScene() ?? replayLayer.setScene();

        const replayPopup = replayScene.spineAnimations.get("replayPopup")!;

        // Buffalo rush
        const buffaloRush = ViewManager.getLayer(GameLayers.Buffalos)
            .getCurrentScene()
            .spineAnimations.get("buffalo")!;

        const listener: IAnimationStateListener = {
            event(_, event) {
                if (event.data.name === "show_replay_popup") {
                    replayPopup.visible = true;
                    replayPopup.play();
                }
            }
        };

        buffaloRush.state.addListener(listener);

        // Scene shake
        playSceneShake(BURReelsModel.shake_layers);

        // Clear the win from the base spin
        const win = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
        win.clear();

        gsap.delayedCall(1, async () => {
            // Start buffalo rush
            buffaloRush.visible = true;
            await buffaloRush.playAsync(color);

            // Clearup
            stopSceneShake();
            buffaloRush.state.removeListener(listener);
            buffaloRush.visible = false;
            replayPopup.visible = false;

            // Update the spin data
            const respinData = {
                data: {
                    gameData:
                        BURFeatureModel.blue_respin_data as IVendorSpinData
                }
            };
            SpinModel.update(respinData);

            BURReelsModel.reels.spin();

            BURReelsModel.reels.once(GameEvents.ALL_REELS_STARTED, () => {
                this.exit();
            });
        });
    }
}
